import { render } from "./ProfitAndLossComparison.vue?vue&type=template&id=3348abd2"
import script from "./ProfitAndLossComparison.vue?vue&type=script&lang=js"
export * from "./ProfitAndLossComparison.vue?vue&type=script&lang=js"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__